import { Helmet } from 'react-helmet-async';

export default function SEO({ title, description, url, image }) {
  const defaultTitle = "Pomie Studio | Interiors, Graphic Design & Product Design";
  const defaultDescription = "Pomie Studio is a premium design practice specializing in bespoke interiors, strategic graphic design, and innovative product design.";
  const siteUrl = "https://pomiestudio.com"; // Base URL
  const defaultImage = `${siteUrl}/og-image.jpg`;

  const currentTitle = title ? `${title} | Pomie Studio` : defaultTitle;
  const currentDescription = description || defaultDescription;
  const currentUrl = url ? `${siteUrl}${url}` : siteUrl;
  const currentImage = image || defaultImage;

  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>{currentTitle}</title>
      <meta name="description" content={currentDescription} />
      <link rel="canonical" href={currentUrl} />

      {/* Open Graph / Facebook / WhatsApp */}
      <meta property="og:type" content="website" />
      <meta property="og:url" content={currentUrl} />
      <meta property="og:title" content={currentTitle} />
      <meta property="og:description" content={currentDescription} />
      <meta property="og:image" content={currentImage} />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={currentUrl} />
      <meta name="twitter:title" content={currentTitle} />
      <meta name="twitter:description" content={currentDescription} />
      <meta name="twitter:image" content={currentImage} />
    </Helmet>
  );
}